export default __webpack_public_path__ + "static/media/melltoo-img2.1f36bb92.png";